import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/LogoHeaderConvertido.webp'


const _withScopeId = n => (_pushScopeId("data-v-15fa5610"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo__logo",
  src: _imports_0,
  alt: "Logo de Chatterbox English Studio"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Chatterbox - English Studio", -1))
const _hoisted_5 = {
  key: 0,
  class: "header__desktop__navigation"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" HOME ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" CLASSES ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" CHATTER&CO ")
const _hoisted_9 = {
  key: 1,
  id: "navigation__icon",
  class: "navigation__icon"
}
const _hoisted_10 = { class: "header__dropdown__navigation" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" HOME ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" CLASSES ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" CHATTER&CO ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: { name: 'Home' } }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _hoisted_4
      ]),
      (!_ctx.mobileSize)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "navigation__link",
                to: { name: 'Home' }
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "navigation__link",
                to: { name: 'Classes' }
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "navigation__link",
                to: { name: 'Companies' }
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("i", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNavigation && _ctx.toggleMobileNavigation(...args))),
              class: _normalizeClass(["fas fa-bars", { 'fas fa-times': _ctx.mobileNav }]),
              id: "icon__mobileNav"
            }, null, 2)
          ])),
      _createVNode(_Transition, { name: "mobile__nav" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "navigation__link",
                to: { name: 'Home' }
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "navigation__link",
                to: { name: 'Classes' }
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "navigation__link",
                to: { name: 'Companies' }
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, _ctx.mobileNav]
          ])
        ]),
        _: 1
      })
    ])
  ]))
}